import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, ViewEncapsulation } from '@angular/core';
import {CommonModule} from "@angular/common";
import {RouterModule} from "@angular/router";
import { ConfigService } from 'src/app/services/config.service';
import { AuthService } from 'src/app/services/auth.service'
import {AssetsService} from '../../services/assets.service'

@Component({
  selector: 'fleet-landing-page',
  standalone: true,
  imports: [CommonModule, RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './landing.component.html',
  styleUrl: './landing.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class LandingPageComponent implements OnInit {
  configService:ConfigService;
  isSession:boolean=false
  img1:any;
  img2:any;
  constructor(configService:ConfigService, private authService: AuthService, private assetsService: AssetsService) {
    this.configService = configService
    this.isSession = this.authService.loggedInStatus
      
  }
  ngOnInit() {
    this.setAssets()
  }
  setAssets() {
    this.img1=
      this.assetsService.getAsset('landing')
    this.img2 =
      this.assetsService.getAsset('landing-report')
  
  
  }
  /* generateLink(relativePath:string){
    return this.configService.generateLink(relativePath)
  } */
}
